import ArrowLeftIcon from './arrow-left.js'
import BlockIcon from './block.js'
import ChevronDownIcon from './chevron-down.js'
import CopyIcon from './copy.js'
import FlipIcon from './flip.js'
import FunctionIcon from './function.js'
import GithubIcon from './github.js'
import MagnifyingGlassIcon from './magnifying-glass.js'
import SelectorIcon from './selector.js'

const variants = {
  'arrow-left': ArrowLeftIcon,
  'chevron-down': ChevronDownIcon,
  'magnifying-glass': MagnifyingGlassIcon,
  block: BlockIcon,
  copy: CopyIcon,
  flip: FlipIcon,
  function: FunctionIcon,
  github: GithubIcon,
  selector: SelectorIcon,
}

export default variants
